/* =========================================================
   eSplicito · PAGAR AHORA rápido
   - Al tocar el botón se va al pago de inmediato.
   - El botón cambia al instante a "Abriendo pago seguro" para
     que el cliente vea que sí está cargando y no toque dos veces.
   - Si el cliente vuelve atrás, el botón queda normal otra vez.
   ========================================================= */
(function () {
  'use strict';
  var ORIGINAL = null;

  function reset() {
    var b = document.getElementById('cs-checkout');
    if (!b || !b.dataset.going) return;
    delete b.dataset.going;
    b.classList.remove('cs-cta-loading');
    if (ORIGINAL !== null) b.innerHTML = ORIGINAL;
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#cs-checkout') : null;
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (b.dataset.going) return;
    b.dataset.going = '1';
    if (ORIGINAL === null) ORIGINAL = b.innerHTML;
    b.classList.add('cs-cta-loading');
    b.innerHTML = '<span class="cs-spin" aria-hidden="true"></span>ABRIENDO PAGO SEGURO';
    window.location.assign('/checkout');
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) reset();
  });
})();
